// removed by extract-text-webpack-plugin
module.exports = {"root":"Subscriptions__root___2Vxy9","subscription":"Subscriptions__subscription___1suO1","package":"Subscriptions__package___2zD49","current":"Subscriptions__current___3buPv"};